<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="chosenDate"
        :label="label"
        append-icon="event"
        readonly
        outlined
        dense
        v-on="on"
        :color="color"
        :class="textfieldClass"
      ></v-text-field>
    </template>
    <v-date-picker 
      :color="color" 
      v-model="chosenDate" 
      no-title 
      scrollable 
      @input="menu = false"
      :allowed-dates="allowedDates" />
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false
    }
  },
  computed: {
    chosenDate: {
      get() {
        return this.date
      },
      set(value) {
        this.$emit('changed', value)
      }
    }
  },
  props: ['date','label','color','textfieldClass'],
  model: {
    prop: 'date',
    event: 'changed'
  },
  methods: {
    allowedDates: val => new Date(val) <= Date.now()
  }
}
</script>